"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServiceIssueMockStates = void 0;
var ServiceIssueMockStates;
(function (ServiceIssueMockStates) {
    // Update card - generic
    ServiceIssueMockStates["UPDATE_DEBIT_CARD"] = "updateDebitCard";
    ServiceIssueMockStates["IN_APP_DOWNPAYMENT"] = "inAppDownpayment";
    ServiceIssueMockStates["IN_APP_DOWNPAYMENT_FAILED"] = "inAppDownpaymentFailed";
    ServiceIssueMockStates["IN_APP_DOWNPAYMENT_RATE_LIMITING"] = "inAppDownpaymentRateLimiting";
    ServiceIssueMockStates["INSUFFICIENT_FUNDS"] = "insufficientFunds";
    ServiceIssueMockStates["GENERIC_PAYMENT_FAILURE"] = "genericPaymentFailure";
    ServiceIssueMockStates["DEFAULT_PAYMENT_FAILURE"] = "defaultPaymentFailure";
    ServiceIssueMockStates["PAST_DOWNPAYMENT_DEADLINE"] = "pastDownpaymentDeadline";
    // Update card - Flex Classic SLC
    ServiceIssueMockStates["SLC_UPDATE_CARD"] = "slcUpdateCard";
    ServiceIssueMockStates["SLC_INSUFFICIENT_FUNDS"] = "slcInsufficientFunds";
    ServiceIssueMockStates["SLC_GENERIC_PAYMENT_FAILURE"] = "slcGenericPaymentFailure";
    ServiceIssueMockStates["SLC_DEFAULT_PAYMENT_FAILURE"] = "slcDefaultPaymentFailure";
    // Update card - Flex Classic Episodic
    ServiceIssueMockStates["EP_INSUFFICIENT_FUNDS"] = "epInsufficientFunds";
    ServiceIssueMockStates["EP_GENERIC_PAYMENT_FAILURE"] = "epGenericPaymentFailure";
    ServiceIssueMockStates["EP_DEFAULT_PAYMENT_FAILURE"] = "epDefaultPaymentFailure";
    ServiceIssueMockStates["EP_UPDATE_CARD"] = "epUpdateCard";
    // Update card - Flex Anywhere
    ServiceIssueMockStates["FA_INSUFFICIENT_FUNDS"] = "faInsufficientFunds";
    ServiceIssueMockStates["FA_GENERIC_PAYMENT_FAILURE"] = "faGenericPaymentFailure";
    ServiceIssueMockStates["FA_DEFAULT_PAYMENT_FAILURE"] = "faDefaultPaymentFailure";
    ServiceIssueMockStates["FA_UPDATE_CARD"] = "faUpdateCard";
    // Refund - Flex Anywhere
    ServiceIssueMockStates["FA_SETTLEMENT_PENDING"] = "faSettlementPending";
    // Self Pay - VC (card)
    ServiceIssueMockStates["SELF_PAY_VC"] = "selfPayVC";
    ServiceIssueMockStates["VC_ISSUED"] = "vcIssued";
    ServiceIssueMockStates["VC_ISSUED_SLC"] = "vcIssuedSLC";
    ServiceIssueMockStates["SELF_PAY_VC_PENDING_BEFORE_BP_CLOSE"] = "selfPayVcPendingBpWindowOpen";
    ServiceIssueMockStates["VC_CANNOT_CANCEL"] = "vcCannotCancel";
    ServiceIssueMockStates["BLOCK_SWITCH_TO_DEBIT"] = "blockSwitchToDebit";
    ServiceIssueMockStates["BLOCK_SWITCH_TO_DEBIT_CANCEL_AUTH"] = "blockSwitchToDebitCancelAuth";
    // Self Pay - DDA (bank account)
    ServiceIssueMockStates["DDA"] = "dda";
    ServiceIssueMockStates["DDA_ISSUED"] = "ddaIssued";
    ServiceIssueMockStates["SELF_PAY_DDA_PENDING_BEFORE_BP_CLOSE"] = "selfPayDdaPendingBpWindowOpen";
    // Self Pay - Generic
    ServiceIssueMockStates["SELF_PAY_PENDING_AFTER_BP_CLOSE"] = "selfPayPending";
    ServiceIssueMockStates["SELF_PAY_OPTED_OUT"] = "selfPayOptedOut";
    // Balance Too High / Low
    ServiceIssueMockStates["BALANCE_TOO_HIGH"] = "balanceTooHigh";
    ServiceIssueMockStates["BALANCE_TOO_HIGH_PAST_DUE"] = "balanceTooHighPastDue";
    ServiceIssueMockStates["BALANCE_TOO_LOW"] = "balanceTooLow";
    ServiceIssueMockStates["ZERO_BALANCE"] = "zeroBalance";
    ServiceIssueMockStates["YARDI_ZERO_BALANCE"] = "yardiZeroBalance";
    ServiceIssueMockStates["SLC_BALANCE_TOO_HIGH"] = "slcBalanceTooHigh";
    ServiceIssueMockStates["SLC_BALANCE_TOO_LOW"] = "slcBalanceTooLow";
    ServiceIssueMockStates["BTL_CAN_OVERWRITE_HIGHER"] = "btlCanOverwriteHigher";
    ServiceIssueMockStates["BTL_CANNOT_OVERWRITE"] = "btlCannotOverwrite";
    ServiceIssueMockStates["BTH_CAN_OVERWRITE_HIGHER"] = "bthCanOverwriteHigher";
    ServiceIssueMockStates["BTH_CANNOT_OVERWRITE"] = "bthCannotOverwrite";
    ServiceIssueMockStates["BTL_CAN_OVERWRITE_EITHER"] = "btlCanOverwriteEither";
    ServiceIssueMockStates["BTH_CAN_OVERWRITE_EITHER"] = "bthCanOverwriteEither";
    // Property connection
    ServiceIssueMockStates["RELINK"] = "relink";
    ServiceIssueMockStates["CREDIT_BUILDER_RELINK"] = "creditBuilderRelink";
    ServiceIssueMockStates["PAST_DUE_RENT"] = "pastDueRent";
    ServiceIssueMockStates["PORTAL_CREDENTIALS_RELINK"] = "portalCredentialsRelink";
    // Generic messaging
    ServiceIssueMockStates["ISSUE_MESSAGING"] = "issueMessaging";
})(ServiceIssueMockStates || (exports.ServiceIssueMockStates = ServiceIssueMockStates = {}));
